import React from 'react';
import {
  chakra,
  Heading,
  Text,
  VStack,
  Wrap,
} from '@chakra-ui/react';
import { RadioButton } from '../RadioButton';
import { useField } from 'react-final-form';

const PricePlanView = ({
  plans,
}: {
  plans: Array<{ label: string, value: string }>,
}): JSX.Element => {

  const predicate = (a: any, b: any) => a === b;
  const options = plans;

  const field = useField('plan');
  const plan = field.input.value;
  const errors = { plan: field.meta.error };

  return (
    <>
      <fieldset>
        <legend>
          <Heading fontSize="2xl" mb={6}>Price Plan</Heading>
        </legend>

        <Wrap display="block" spacing={3}>
          {options.map((o: any, i: number) => {
            const isSelected = predicate(plan, o.value) || !plan && i === 0;
            return (
              <RadioButton
                key={o.value}
                isActive={isSelected}
                onClick={() => field.input.onChange(o.value)}
              >
                {o.label}
              </RadioButton>
            );
          })}
        </Wrap>
        {errors.plan && (
          <Text color="red.300" fontSize="sm" mt={2} px={4}>Please select a price plan.</Text>
        )}
      </fieldset>
    </>
  );
};

export default PricePlanView;
